'use client';

import { useEffect } from 'react';
import { bootstrapEventSubscribers } from '@/features/events/bootstrap';
import { useThirdPartyScriptsConfig } from '@/features/third-party-scripts/use-third-party-scripts-config';
export function EventBusBootstrap() {
  const {
    data
  } = useThirdPartyScriptsConfig();
  useEffect(() => {
    if (typeof window === 'undefined' || !data) return;
    bootstrapEventSubscribers(data);
  }, [data]);
  return null;
}